import { amritanshu, parasar } from "../../static/webP/upi-payment-gateway";
import { UPI_PAYMENT_GATEWAY_ASSETS_URL } from "./Url";

export const selector = "video-tabs";
export const upiPGAssets = {
  heroMp4: `${UPI_PAYMENT_GATEWAY_ASSETS_URL}/hero-video-upi.mp4`,
  heroWebm: `${UPI_PAYMENT_GATEWAY_ASSETS_URL}/hero-video-upi.webm`,
};

export const heroLogoData = [
  {
    id: 0,
    src: "phonepe.png",
    alt: "PhonePe",
    width: "312",
    height: "93",
  },
  {
    id: 1,
    src: "googlepay.png",
    alt: "Google Pay",
    width: "375",
    height: "67",
  },
  {
    id: 2,
    src: "paytm.png",
    alt: "Paytm",
    width: "243",
    height: "78",
  },
  {
    id: 3,
    src: "bhim.png",
    alt: "Bhim",
    width: "304",
    height: "99",
  },
  {
    id: 4,
    src: "amazonpay.png",
    alt: "Amazon Pay",
    width: "177",
    height: "150",
  },
  {
    id: 5,
    src: "whatsapp.png",
    alt: "Whatsapp",
    width: "359",
    height: "84",
  },
  {
    id: 6,
    src: "tataneu.png",
    alt: "TATA NEU",
    width: "192",
    height: "133",
  },
  {
    id: 7,
    src: "andmore.png",
    alt: "And more",
    width: "232",
    height: "36",
  },
];
export const quotes = [
  {
    id: 0,
    partner: {
      src: amritanshu,
      width: "630",
      height: "400",
      alt: "amritanshu",
    },
    companyLogo: {
      src: `${UPI_PAYMENT_GATEWAY_ASSETS_URL}/zepto.png`,
      width: "83",
      height: "28",
      alt: "Zepto",
    },
    name: "Amritansu Nanda",
    designation: "Chief Marketing Officer, Zepto",
    quote:
      "As a service that prioritises convenience, our association with Cashfree Payments enables a seamless UPI payment experience for our customers.",
  },
  {
    id: 1,
    partner: {
      src: parasar,
      width: "630",
      height: "400",
      alt: "parasar",
    },
    companyLogo: {
      src: `${UPI_PAYMENT_GATEWAY_ASSETS_URL}/wakefit.png`,
      width: "91",
      height: "39",
      alt: "Wakefit",
    },
    name: "Parasar Sarma",
    designation: "Vice President of Growth, Wakefit",
    quote:
      "We saw that the UPI success percentages with other payment aggregators were a little low. With Cashfree’s Payment Gateway, we experienced a tremendous increase in our success rates in UPI. This has helped us increase our customer conversion ratio.",
  },
];

export const upiPaymentLinkCheckList = [
  {
    id: 0,
    text: "APIs that are easy to integrate",
  },
  {
    id: 1,
    text: "Embed links on your website or mobile app",
  },
  {
    id: 2,
    text: "Allow your users to pay without entering the amount",
  },
];

export const qrCodeCheckList = [
  {
    id: 0,
    text: "Generate and display dynamic QR code on your website or softPOS app",
  },
  {
    id: 1,
    text: "Use our APIs and make it easy for your customers to pay",
  },
];

export const virtualUpiIdCheckList = [
  {
    id: 0,
    text: "Create unique virtual UPI IDs assigned to every payer",
  },
  {
    id: 1,
    text:
      "Automatically reconcile all the UPI payments received from different customers",
  },
  {
    id: 2,
    text: "Allow your users to pay without entering the amount",
  },
];

export const heroSliderSettings = {
  dots: false,
  arrows: false,
  infinite: false,
  autoplay: false,
  autoplaySpeed: 0,
  swipe: false,
  pauseOnHover: false,
  draggable: false,
  centerMode: false,
  speed: 2000,
  slidesToShow: heroLogoData.length,
  variableWidth: true,
  cssEase: "linear",
  responsive: [
    {
      breakpoint: 500,
      settings: {
        rtl: true,
        draggable: false,
        autoPlay: true,
        autoplay: true,
        speed: 2000,
        swipe: false,
        autoplaySpeed: 2000,
        cssEase: "linear",
        slidesToShow: 2.8,
        infinite: true,
        centerMode: false,
        variableWidth: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        rtl: true,
        draggable: false,
        autoPlay: true,
        autoplay: true,
        speed: 2000,
        swipe: false,
        autoplaySpeed: 2000,
        cssEase: "linear",
        slidesToShow: 5,
        infinite: true,
        centerMode: false,
        variableWidth: true,
      },
    },
    {
      breakpoint: 990,
      settings: {
        rtl: true,
        draggable: false,
        autoPlay: true,
        autoplay: true,
        speed: 2000,
        swipe: false,
        autoplaySpeed: 2000,
        cssEase: "linear",
        slidesToShow: 6,
        infinite: true,
        centerMode: false,
        variableWidth: true,
      },
    },
  ],
};

export const checkList = [
  {
    id: 0,
    text: "Get quicker access to the latest features enabled by NPCI",
  },
  {
    id: 1,
    text: "Reduce payment failures by 20%",
  },
  {
    id: 2,
    text: "Process ∼12K transactions per second",
  },
  {
    id: 3,
    text: "Reduce latency by 30%",
  },
  {
    id: 4,
    text: "Manage refunds and disputes hassle-free",
  },
];
